import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SoftSelect from '../../../../components/SoftSelect';
import { policyCancellationRefundEligibility } from '../const/policyCancellationRefundEligibility';

const RefundEligibilitySelect = ({ value, onChange, className }) => {
  const { t } = useTranslation();

  return (
    <Box className={className}>
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        {t('POLICY_CANCELLATION.refundEligibility.label')}
        <span aria-hidden="true"> *</span>
      </Typography>
      <SoftSelect
        required
        placeholder={t('POLICY_CANCELLATION.refundEligibility.placeholder')}
        options={policyCancellationRefundEligibility}
        value={value}
        onChange={onChange}
        className="refund-eligibility-dropdown-select"
      />
    </Box>
  );
};

RefundEligibilitySelect.propTypes = {
  className: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default RefundEligibilitySelect;
